import React, { Component } from "react";
import { Row, Col, Button, Form, Select, message, Input, Checkbox } from "antd";
import "./Notes.css";
import { withRouter } from "react-router-dom";
import { API } from "../../../API/API";
const { TextArea } = Input;
class NotesAdd extends Component {
  formRef = React.createRef();
  state = {
    noteid: this.props.noteid,
    invitationid: this.props.invitationid,
    address: "Хан-Уул дүүрэг, I хороо, XIX хороолол Чингисийн өргөн чөлөө, “Монголын Алт” (МАК) ХХК-ийн төв байр-44 Улаанбаатар хот 17030, Ш/х-66",
    phone: "",
    email: "",
    post: true,
    electron: true,
    isEdit: this.props.isEdit,
    dkey: 1,
  };
  componentDidMount = () => {
    this.getData();
  };
  getData = () => {
    API.get("/getNoteInitialData?noteid=" + this.state.noteid).then(
      (response) => {
        if (response.status === 200) {
          if (response.data.retData.length > 0) {
            this.setState((prevState) => ({
              address: response.data.retData[0].address,
              phone: response.data.retData[0].phone,
              email: response.data.retData[0].email,
              post: response.data.retData[0].post === 1 ? true : false,
              electron: response.data.retData[0].electron === 1 ? true : false,
              dkey: prevState.dkey + 1,
            }));
          }
        }
      }
    );
  };
  onChangeAddress = (e) => {
    this.setState({ address: e.target.value });
  };
  onChangePhone = (e) => {
    this.setState({ phone: e.target.value });
  };
  onChangeEmail = (e) => {
    this.setState({ email: e.target.value });
  };
  onChangePost = (e) => {
    this.setState({ post: e.target.checked });
  };
  onChangeElectron = (e) => {
    this.setState({ electron: e.target.checked });
  };
  onSave = () => {
    if (this.state.address && this.state.phone && this.state.email) {
      let body = {
        noteid: this.state.noteid,
        invitationid: this.state.invitationid,
        address: this.state.address,
        phone: this.state.phone,
        email: this.state.email,
        post: this.state.post ? 1 : 0,
        electron: this.state.electron ? 1 : 0,
      };
      API.post("/saveNote", body).then((response) => {
        if (response.status === 200) {
          message.success("Амжилттай хадгаллаа.");
          this.props.showForm(false, 0);
        }
      });
    }
  };
  render() {
    return (
      <div id="criteria" key={this.state.dkey}>
        <Form
          className="formDrawer"
          ref={this.formRef}
          onFinish={this.onSubmit}
          layout="vertical"
          initialValues={{}}
        >
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form.Item
                style={{ fontWeight: 700 }}
                label="Хаяг"
                name="address"
                initialValue={this.state.address}
                rules={[
                  {
                    required: true,
                    message: "Хаяг оруулна уу.",
                  },
                ]}
              >
                <TextArea
                  onChange={this.onChangeAddress}
                  rows={5}
                  value={this.state.address}
                  disabled={this.state.isEdit ? false : true}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form.Item
                style={{ fontWeight: 700 }}
                label="Холбоо барих утас"
                name="phone"
                initialValue={this.state.phone}
                rules={[
                  {
                    required: true,
                    message: "Холбоо барих утас оруулна уу.",
                  },
                ]}
              >
                <Input
                  onChange={this.onChangePhone}
                  size="middle"
                  value={this.state.phone}
                  disabled={this.state.isEdit ? false : true}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form.Item
                style={{ fontWeight: 700 }}
                label="И-мэйл хаяг"
                name="email"
                initialValue={this.state.email}
                rules={[
                  {
                    required: true,
                    message: "И-мэйл хаяг оруулна уу.",
                  },
                ]}
              >
                <Input
                  onChange={this.onChangeEmail}
                  size="middle"
                  value={this.state.email}
                  disabled={this.state.isEdit ? false : true}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Form.Item
                style={{ fontWeight: 700 }}
                label="Цахим"
                name="electron"
                initialValue={this.state.electron ? true : false}
              >
                <Checkbox
                  onChange={this.onChangeElectron}
                  defaultChecked={this.state.electron ? true : false}
                  disabled={this.state.isEdit ? false : true}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                style={{ fontWeight: 700 }}
                label="Хаягаар ирүүлэх"
                name="post"
                initialValue={this.state.post ? true : false}
              >
                <Checkbox
                  onChange={this.onChangePost}
                  defaultChecked={this.state.post ? true : false}
                  disabled={this.state.isEdit ? false : true}
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item className="buttonForm" label=" ">
            <Button
              type="primary"
              style={{
                width: "100%",
                backgroundColor: "#0358A7",
                borderRadius: 2,
                height: 40,
              }}
              htmlType="submit"
              onClick={this.onSave}
              disabled={this.state.isEdit ? false : true}
            >
              Нэмэлт мэдээлэл нэмэх
            </Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

export default withRouter(NotesAdd);
